export default __webpack_public_path__ + "static/media/flag-ch.f140ba7d.svg";